import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import Filtro_ObjetivoMensual from "../ObjetivoMensual/Filtro_ObjetivoMensual";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import WalletIcon from "@mui/icons-material/Wallet";
import { CapitalizarCadena } from "../../../Helpers/CaptitalizarCadena";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import ChartRecuperacionCarteraMensual from "./ChartRecuperaciondeCarteraMensual";
import { useBox } from "../ReporteCobranza/Helper/useBox";
import { GetKey } from "../ReporteCobranza/Actions/GetContainer";
import Swal from "sweetalert2";
import { GetMonthName } from "../../helpers/GetMonthName";
import PostAddIcon from '@mui/icons-material/PostAdd';
import FiltroRecuperacionCartera from "./FiltroRecuperacionCartera";
const RecuperacionCarteraCompletaScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const permisos = location.state;
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);
  const [boxstate, setBoxState] = useBox();
  const storedState = JSON.parse(localStorage.getItem("state")) || {};
  const [titulo, setTitulo] = useState("RECUPERACION DE CARTERA");

  const [state, setState] = useState({
    total: [],
    operacion: [],
    revolvente: [],
    especial: [],
    juridico: [],
  });

  const [stateFiltro, setStateFiltro] = useState({
    periodo: storedState.periodo || boxstate.periodo,
    ejercicio: storedState.ejercicio || boxstate.ejercicio,
    adr: (storedState.adr ? storedState.adr.filter(item => item.checked).map(({ idadr, adr }) => ({ idadr, adr })) : boxstate.pv.adr),
    sucursal: (storedState.sucursal ? storedState.sucursal.filter(item => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal })) : boxstate.pv.sucursal)
  });



  const [showAll, setShowAll] = useState(false);
  const [showAllop, setShowAllop] = useState(false);
  const [showAllrev, setShowAllrev] = useState(false);
  const [showAllesp, setShowAllesp] = useState(false);
  const [showAlljur, setShowAlljur] = useState(false);
  const mesMostrado = GetMonthName(stateFiltro.periodo);

  useEffect(() => {
    setStateFiltro({
      ejercicio: storedState.ejercicio || boxstate.ejercicio,
      periodo: storedState.periodo || boxstate.periodo,
      adr: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal
    });
  }, [boxstate]);

  const onHome = () => {
    history.push("/Creditoycobranza/Main");
  };
  const onExecute = (ejercicio, periodo) => {
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);

    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);

      }
      else {
        sucursales = "0"
      }
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `ReporteRecuperacionCompleta/ObtenerRecuperacion?ejercicio=${Number(
            ejercicio
          )}&sucursales=${sucursales}&adr=${adr}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setState({
            total: result.total,
            operacion: result.operacion,
            revolvente: result.revolvente,
            especial: result.especial,
            juridico: result.juridico,
          });
          setTitulo(
            `RECUPERACION DE CARTERA 
             ${GetMonthName(
              stateFiltro.periodo
            ).toUpperCase()}
             ${ejercicio}`
          );
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };
  useEffect(() => {
    const añoActual = new Date().getFullYear();
    onExecute(stateFiltro.ejercicio, stateFiltro.periodo);
  }, []);

  const GetClassIndicador = (value) => {
    if (value === "R") return "alert-red";
    else if (value === "A") return "alert-yellow";
    else if (value === "V") return "alert-success";
    else return "alert-red";
  };
  const GetClassIndicadordouble = (value) => {
    if (value === "RR") return "alert-red";
    else return "d-none";
  };

  const onGeneraExcel = (ejercicio) => {
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);

      }
      else {
        sucursales = "0"
      }
    }
    // return;
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ReporteRecuperacionCompleta/ImprimirExcel?ejercicio=${Number(
          ejercicio
        )}&sucursales=${sucursales}&adr=${adr}`
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onGeneraPDF = (ejercicio) => {
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if(adr === "0" || adr === "1,2")
      {
        sucursales = GetKey(permisos, ["idsucursal"]);
        
      }
      else {
      sucursales = "0"
      }
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ReporteRecuperacionCompleta/ImprimirPDF?ejercicio=${Number(
          ejercicio
        )}&sucursales=${sucursales}&adr=${adr}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  function FormatMiles(value) {
    if (!value || isNaN(value)) return "0"; // Maneja valores no válidos
    const truncatedValue = Math.trunc(value / 1000); // Divide entre 1000 y trunca
    return `${FormatMoney(truncatedValue, 0)}`; // Formatea como dinero con separadores de miles
  }

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"reporte-recuperacion-cartera-completa"}
    >
      <div className="resumen-saldos-cartera-completa-header-mensual">
        <div className="resumen-saldos-cartera-completa-actions">
          <div
            className="dashboard-cobranza-actions-regresar"
            onClick={() => history.goBack()}
          >
            <ArrowBackIcon /> Regresar
          </div>
          <FiltroRecuperacionCartera
            onExecute={onExecute}
            boxState={boxstate}
            sucursales={permisos}
            onBoxChange={setBoxState}
          />
        </div>
      </div>
      <div className="buttons">
        <button
          className="excel"
          onClick={() => onGeneraExcel(boxstate.ejercicio)}
        >
          <i className=" icon-file-excel" /> Excel
        </button>
        <button
          className="PDF"
          onClick={() => onGeneraPDF(boxstate.ejercicio)}
          style={{ backgroundColor: "#940404" }}
        >
          PDF
        </button>
      </div>
      <div className="resumen-saldos-cartera-completa scroll-4">
        <LoaderScreen loader={loader} />
        <span className="ta-center">
          (Cantidades expresadas en miles de pesos)
        </span>
        {state.total !== undefined &&
          state.total !== undefined &&
          state.total.length > 0 ? (
          <>
            <div className="resumen-saldos-cartera-completa-titulo">
              <WalletIcon />
              Total Cartera
            </div>
            <div className="resumen-saldos-cartera-completa-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th colSpan={3}>Objetivo</th>
                    <th colSpan={9}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Por Vencer</th>
                    <th>Vencido</th>
                    <th>Total</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>% de objetivo por vencer recuperado</th>
                    <th></th>
                    <th>Vencida</th>
                    <th>% de objetivo vencido recuperado</th>
                    <th></th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>% de objetivo total recuperado</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // state.total.map((item, index) => (
                    (showAll === true
                      ? state.total
                      : state.total.filter(item => item.mes === GetMonthName(stateFiltro.periodo).toUpperCase())
                    ).map((item, index) => (
                      <tr>
                        <td>
                          <div className="td-icono-principal">
                            <CalendarMonthIcon />
                            {CapitalizarCadena(item.mes)}
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_activa, 0)}<span className="td-porc-inline">{item.porc_cartera_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_porvencer, 0)}<span className="td-porc-inline">{item.porc_cartera_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_vencida, 0)}<span className="td-porc-inline">{item.porc_cartera_vencida} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.total_cartera, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_porvencer, 0)}<span className="td-porc-inline">{item.porc_objetivo_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_vencido, 0)}<span className="td-porc-inline">{item.porc_objetivo_vencido} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_mes, 0)}<span className="td-porc-inline">{item.porc_recuperacion_mes} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_activa, 0)}<span className="td-porc-inline">{item.porc_recuperacion_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_porvencer, 0)}<span className="td-porc-inline">{item.porc_recuperacion_porvencer} %</span></div></td>
                        <td className="ta-right">{item.porcporvencer}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorporvencer)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorporvencer)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_vencida, 0)}<span className="td-porc-inline">{item.porc_recuperacion_vencida} %</span></div></td>
                        <td className="ta-right">{item.porcvencido}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorvencido)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorvencido)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.total_recuperado, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td>{FormatMiles(item.recuperado, 0)}</td>
                        <td className="ta-right">{item.porc}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicador)}></div>
                            <div className={GetClassIndicadordouble(item.indicador)}></div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  <tr
                    className="ver-todo"
                    onClick={() => setShowAll(!showAll)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <td colSpan={2}>
                      <PostAddIcon />
                      {showAll ? "Ocultar" : "Mostrar todo"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="resumen-saldos-cartera-completa-titulo">
              <WalletIcon /> Cartera de Operación
            </div>
            <div className="resumen-saldos-cartera-completa-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th colSpan={3}>Objetivo</th>
                    <th colSpan={9}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Por Vencer</th>
                    <th>Vencido</th>
                    <th>Total</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>% de objetivo por vencer recuperado</th>
                    <th></th>
                    <th>Vencida</th>
                    <th>% de objetivo vencido recuperado</th>
                    <th></th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>% de objetivo total recuperado</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // state.operacion.map((item) => (
                    (showAllop === true
                      ? state.operacion
                      : state.operacion.filter(item => item.mes === GetMonthName(stateFiltro.periodo).toUpperCase())
                    ).map((item, index) => (
                      <tr>
                        <td>
                          <div className="td-icono-principal">
                            <CalendarMonthIcon />
                            {CapitalizarCadena(item.mes)}
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_activa, 0)}<span className="td-porc-inline">{item.porc_cartera_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_porvencer, 0)}<span className="td-porc-inline">{item.porc_cartera_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_vencida, 0)}<span className="td-porc-inline">{item.porc_cartera_vencida} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.total_cartera, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_porvencer, 0)}<span className="td-porc-inline">{item.porc_objetivo_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_vencido, 0)}<span className="td-porc-inline">{item.porc_objetivo_vencido} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_mes, 0)}<span className="td-porc-inline">{item.porc_recuperacion_mes} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_activa, 0)}<span className="td-porc-inline">{item.porc_recuperacion_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_porvencer, 0)}<span className="td-porc-inline">{item.porc_recuperacion_porvencer} %</span></div></td>
                        <td className="ta-right">{item.porcporvencer}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorporvencer)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorporvencer)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_vencida, 0)}<span className="td-porc-inline">{item.porc_recuperacion_vencida} %</span></div></td>
                        <td className="ta-right">{item.porcvencido}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorvencido)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorvencido)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.total_recuperado, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td>{FormatMiles(item.recuperado, 0)}</td>
                        <td className="ta-right">{item.porc}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicador)}></div>
                            <div className={GetClassIndicadordouble(item.indicador)}></div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  <tr
                    className="ver-todo"
                    onClick={() => setShowAllop(!showAllop)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <td colSpan={2}>
                      <PostAddIcon />
                      {showAllop ? "Ocultar" : "Mostrar todo"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="resumen-saldos-cartera-completa-titulo">
              <WalletIcon />
              Cartera Revolvente
            </div>
            <div className="resumen-saldos-cartera-completa-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th colSpan={3}>Objetivo</th>
                    <th colSpan={9}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Por Vencer</th>
                    <th>Vencido</th>
                    <th>Total</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>% de objetivo por vencer recuperado</th>
                    <th></th>
                    <th>Vencida</th>
                    <th>% de objetivo vencido recuperado</th>
                    <th></th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>% de objetivo total recuperado</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // state.revolvente.map((item) => (
                    (showAllrev === true
                      ? state.revolvente
                      : state.revolvente.filter(item => item.mes === GetMonthName(stateFiltro.periodo).toUpperCase())
                    ).map((item, index) => (
                      <tr>
                        <td>
                          <div className="td-icono-principal">
                            <CalendarMonthIcon />
                            {CapitalizarCadena(item.mes)}
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_activa, 0)}<span className="td-porc-inline">{item.porc_cartera_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_porvencer, 0)}<span className="td-porc-inline">{item.porc_cartera_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_vencida, 0)}<span className="td-porc-inline">{item.porc_cartera_vencida} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.total_cartera, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_porvencer, 0)}<span className="td-porc-inline">{item.porc_objetivo_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_vencido, 0)}<span className="td-porc-inline">{item.porc_objetivo_vencido} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_mes, 0)}<span className="td-porc-inline">{item.porc_recuperacion_mes} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_activa, 0)}<span className="td-porc-inline">{item.porc_recuperacion_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_porvencer, 0)}<span className="td-porc-inline">{item.porc_recuperacion_porvencer} %</span></div></td>
                        <td className="ta-right">{item.porcporvencer}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorporvencer)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorporvencer)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_vencida, 0)}<span className="td-porc-inline">{item.porc_recuperacion_vencida} %</span></div></td>
                        <td className="ta-right">{item.porcvencido}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorvencido)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorvencido)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.total_recuperado, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td>{FormatMiles(item.recuperado, 0)}</td>
                        <td className="ta-right">{item.porc}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicador)}></div>
                            <div className={GetClassIndicadordouble(item.indicador)}></div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  <tr
                    className="ver-todo"
                    onClick={() => setShowAllrev(!showAllrev)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <td colSpan={2}>
                      <PostAddIcon />
                      {showAllrev ? "Ocultar" : "Mostrar todo"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="resumen-saldos-cartera-completa-titulo">
              <WalletIcon />
              Cartera Especial
            </div>
            <div className="resumen-saldos-cartera-completa-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th colSpan={3}>Objetivo</th>
                    <th colSpan={9}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Por Vencer</th>
                    <th>Vencido</th>
                    <th>Total</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>% de objetivo por vencer recuperado</th>
                    <th></th>
                    <th>Vencida</th>
                    <th>% de objetivo vencido recuperado</th>
                    <th></th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>% de objetivo total recuperado</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // state.especial.map((item) => (
                    (showAllesp === true
                      ? state.especial
                      : state.especial.filter(item => item.mes === GetMonthName(stateFiltro.periodo).toUpperCase())
                    ).map((item, index) => (
                      <tr>
                        <td>
                          <div className="td-icono-principal">
                            <CalendarMonthIcon />
                            {CapitalizarCadena(item.mes)}
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_activa, 0)}<span className="td-porc-inline">{item.porc_cartera_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_porvencer, 0)}<span className="td-porc-inline">{item.porc_cartera_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_vencida, 0)}<span className="td-porc-inline">{item.porc_cartera_vencida} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.total_cartera, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_porvencer, 0)}<span className="td-porc-inline">{item.porc_objetivo_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_vencido, 0)}<span className="td-porc-inline">{item.porc_objetivo_vencido} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_mes, 0)}<span className="td-porc-inline">{item.porc_recuperacion_mes} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_activa, 0)}<span className="td-porc-inline">{item.porc_recuperacion_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_porvencer, 0)}<span className="td-porc-inline">{item.porc_recuperacion_porvencer} %</span></div></td>
                        <td className="ta-right">{item.porcporvencer}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorporvencer)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorporvencer)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_vencida, 0)}<span className="td-porc-inline">{item.porc_recuperacion_vencida} %</span></div></td>
                        <td className="ta-right">{item.porcvencido}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorvencido)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorvencido)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.total_recuperado, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td>{FormatMiles(item.recuperado, 0)}</td>
                        <td className="ta-right">{item.porc}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicador)}></div>
                            <div className={GetClassIndicadordouble(item.indicador)}></div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  <tr
                    className="ver-todo"
                    onClick={() => setShowAllesp(!showAllesp)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <td colSpan={2}>
                      <PostAddIcon />
                      {showAllesp ? "Ocultar" : "Mostrar todo"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="resumen-saldos-cartera-completa-titulo">
              <WalletIcon />
              Cartera Juridica
            </div>
            <div className="resumen-saldos-cartera-completa-table">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Cartera</th>
                    <th colSpan={3}>Objetivo</th>
                    <th colSpan={9}>Recuperacion de Cartera</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Periodo</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>Vencida</th>
                    <th>Total</th>
                    <th>Por Vencer</th>
                    <th>Vencido</th>
                    <th>Total</th>
                    <th>Mes</th>
                    <th>Activa</th>
                    <th>Por Vencer</th>
                    <th>% de objetivo por vencer recuperado</th>
                    <th></th>
                    <th>Vencida</th>
                    <th>% de objetivo vencido recuperado</th>
                    <th></th>
                    <th>Total</th>
                    <th>Objetivo Recuperado</th>
                    <th>% de objetivo total recuperado</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // state.juridico.map((item) => (
                    (showAlljur === true
                      ? state.juridico
                      : state.juridico.filter(item => item.mes === GetMonthName(stateFiltro.periodo).toUpperCase())
                    ).map((item, index) => (
                      <tr>
                        <td>
                          <div className="td-icono-principal">
                            <CalendarMonthIcon />
                            {CapitalizarCadena(item.mes)}
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_activa, 0)}<span className="td-porc-inline">{item.porc_cartera_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_porvencer, 0)}<span className="td-porc-inline">{item.porc_cartera_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.cartera_vencida, 0)}<span className="td-porc-inline">{item.porc_cartera_vencida} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.total_cartera, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_porvencer, 0)}<span className="td-porc-inline">{item.porc_objetivo_porvencer} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo_vencido, 0)}<span className="td-porc-inline">{item.porc_objetivo_vencido} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.objetivo, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_mes, 0)}<span className="td-porc-inline">{item.porc_recuperacion_mes} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_activa, 0)}<span className="td-porc-inline">{item.porc_recuperacion_activa} %</span></div></td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_porvencer, 0)}<span className="td-porc-inline">{item.porc_recuperacion_porvencer} %</span></div></td>
                        <td className="ta-right">{item.porcporvencer}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorporvencer)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorporvencer)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.recuperacion_vencida, 0)}<span className="td-porc-inline">{item.porc_recuperacion_vencida} %</span></div></td>
                        <td className="ta-right">{item.porcvencido}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicadorvencido)}></div>
                            <div className={GetClassIndicadordouble(item.indicadorvencido)}></div>
                          </div>
                        </td>
                        <td><div className="td-valor">{FormatMiles(item.total_recuperado, 0)}<span className="td-porc-inline">100 %</span></div></td>
                        <td>{FormatMiles(item.recuperado, 0)}</td>
                        <td className="ta-right">{item.porc}</td>
                        <td className="td-porcentaje">
                          <div className="porcentaje">
                            <div className={GetClassIndicador(item.indicador)}></div>
                            <div className={GetClassIndicadordouble(item.indicador)}></div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  <tr
                    className="ver-todo"
                    onClick={() => setShowAlljur(!showAlljur)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <td colSpan={2}>
                      <PostAddIcon />
                      {showAlljur ? "Ocultar" : "Mostrar todo"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div></div>
        )}
      </div>
    </PlantillaScreen>
  );
};

export default RecuperacionCarteraCompletaScreen;
